export default "__VITE_ASSET__B71tRRkL__"